export interface ServiceDebitContract {
    id?: number;
    serviceContractId: number
    description: string
    amount: number
    amountPayed: number
    createdAt: string
    status: ServiceDebitStatus
    customer?: string
    categoriesInDetailIds: string[]
    servicesInDetailIds: string[]
}

export enum ServiceDebitStatus {
    EXPIRED = 'EXPIRED',
    PENDING_PAYMENT = 'PENDING',
    PAYED = 'PAYED',
    ABOLISHED = 'ABOLISHED',
}

export interface ServiceContractDebitRecordsFilters {
    status?: string
    customerId?: number
    serviceContractId?: number
}